import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib/utils';
import { ChatMessageProvider } from '../model/context';

type Props = HTMLAttributes<HTMLDivElement> & {
  side?: 'left' | 'right';
  isLast?: boolean;
  className?: string;
};

/**
 * Базовый компонент сообщения чата
 * Создает обертку с контекстом и расположением элементов
 * Использует compound components паттерн для кастомизации
 */
export const ChatMessage: FC<PropsWithChildren<Props>> = ({
  children,
  side = 'left',
  isLast = false,
  className,
  ...props
}) => {
  const isRightSide = side === 'right';

  return (
    <ChatMessageProvider value={{ side, isLast }}>
      <div className={cn('flex items-end gap-2', isRightSide && 'flex-row-reverse', className)} {...props}>
        {children}
      </div>
    </ChatMessageProvider>
  );
};
